if (!customElements.get('mobile-header-categories')) {
class MobileHeaderCategories extends HTMLElement {
  constructor() {
    super();
    this.isInitialized = false;
    this.handleComponentClick = this.handleComponentClick.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.handleDocumentKeydown = this.handleDocumentKeydown.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
  }

  connectedCallback() {
    if (this.isInitialized) return;
    this.isInitialized = true;
    this.addEventListener('click', this.handleComponentClick);
    document.addEventListener('click', this.handleDocumentClick);
    document.addEventListener('keydown', this.handleDocumentKeydown);
    window.addEventListener('resize', this.handleViewportChange);
    window.addEventListener('scroll', this.handleViewportChange, { passive: true });
    this.closeAll();
  }

  disconnectedCallback() {
    if (!this.isInitialized) return;
    this.removeEventListener('click', this.handleComponentClick);
    document.removeEventListener('click', this.handleDocumentClick);
    document.removeEventListener('keydown', this.handleDocumentKeydown);
    window.removeEventListener('resize', this.handleViewportChange);
    window.removeEventListener('scroll', this.handleViewportChange);
    this.isInitialized = false;
  }

  handleComponentClick(event) {
    const trigger = event.target.closest('[data-mobile-category-trigger]');
    if (!trigger || !this.contains(trigger)) return;

    event.preventDefault();
    const category = trigger.closest('[data-mobile-category]');
    const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';
    this.closeAll(category);
    this.setCategoryState(category, shouldOpen);
  }

  handleDocumentClick(event) {
    if (this.contains(event.target)) return;
    this.closeAll();
  }

  handleDocumentKeydown(event) {
    if (event.key !== 'Escape') return;
    const activeTrigger = this.querySelector('[data-mobile-category-trigger][aria-expanded="true"]');
    if (!activeTrigger) return;
    this.closeAll();
    activeTrigger.focus();
  }

  handleViewportChange() {
    if (!this.querySelector('[data-mobile-category-trigger][aria-expanded="true"]')) return;
    this.updateAvailableHeight();
  }

  setCategoryState(category, isOpen) {
    if (!category) return;
    const trigger = category.querySelector('[data-mobile-category-trigger]');
    const panel = category.querySelector('[data-mobile-category-panel]');
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', String(isOpen));
    panel.hidden = !isOpen;
    category.classList.toggle('is-open', isOpen);
    this.classList.toggle(
      'is-category-open',
      Boolean(this.querySelector('[data-mobile-category].is-open')),
    );
    if (isOpen) this.updateAvailableHeight();
  }

  closeAll(exceptCategory = null) {
    this.querySelectorAll('[data-mobile-category]').forEach((category) => {
      if (category !== exceptCategory) this.setCategoryState(category, false);
    });
  }

  updateAvailableHeight() {
    const nav = this.querySelector('.header-mobile-categories__nav');
    if (!nav) return;
    const availableHeight = Math.max(160, window.innerHeight - nav.getBoundingClientRect().bottom - 16);
    this.style.setProperty('--header-mobile-category-available-height', `${Math.round(availableHeight)}px`);
  }
}

  customElements.define('mobile-header-categories', MobileHeaderCategories);
}
